$(document).ready(function(){
// faq tabs toggal start

  // function togal_tabs(item) {
  //   item.addEventListener("click", () => {
  //     toggal_all_tabs(item.getAttribute("data-faq_content"));
  //   });
  // }
  // function toggal_all_tabs(tabs_data) {
  //   let tabs_button = document.querySelectorAll("[data-faq_content]");
  //   tabs_button.forEach((b) => {
  //     if (b.getAttribute("data-faq_content") == tabs_data) {
  //       if (b.classList.contains("is_open")) {
  //         b.classList.remove("is_open");
  //       } else {
  //         b.classList.add("is_open");
  //       }
  //     } else {
  //       b.classList.remove("is_open");
  //     }
  //   });
  // }
  // function faq_taggol() {
  //   let tabs_title = document.querySelectorAll("[data-faq_content]");
  //   tabs_title.forEach(togal_tabs);
  // }
  // faq_taggol();

// faq tabs toggal end

// faq tabs toggal content start
  // function tab_mai_mappert(item) {
  //   item.addEventListener("click", () => {
  //     toggal_all_tabs_content(item.getAttribute("data-hendles"));
  //   });
  // }
  // function toggal_all_tabs_content(tabs_data) {
  //   let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
  //   tabs_content_toggel.forEach((b) => {
  //     if (b.getAttribute("data-hendles") == tabs_data) {
  //       b.classList.add("active");
  //       document.querySelector(b.getAttribute("data-hendles")).style.display =
  //         "block";
  //     } else {
  //       b.classList.remove("active");
  //       document.querySelector(b.getAttribute("data-hendles")).style.display =
  //         "none";
  //     }
  //   });
  // }
  // let tabs_content = document.querySelectorAll("[data-hendles]");
  // tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end
  
  $(document).on("click",".newslatter-popup-wrapper .exit",function() {
        $(".newslatter-popup-wrapper").removeClass("open");
        setCookie("sub_popup_cookie", "News_letter_popup", 24); // 24 hours
    });
  
    function setCookie(cname, cvalue, exhours) {
        var d = new Date();
        d.setTime(d.getTime() + (exhours * 60 * 60 * 1000)); // Expiry time in hours
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }



    // Check if the cookie exists
    function checkCookie() {
        var cookieValue = getCookie("sub_popup_cookie");
        if (cookieValue != "") {
            // console.log("Cookie value is: " + cookieValue);
          $(".newslatter-popup-wrapper").removeClass("open")
        } else {
            // console.log("Cookie expired");
          $(".newslatter-popup-wrapper").addClass("open")
        }
    }

    // Function to get a cookie value
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    // Check the cookie when the page loads
    checkCookie();


  // ================================================
});